<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>品类信息</span>
      </div>
      <el-form
        ref="brandForm"
        :model="brandInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <br />
        <div class="add-form-item">
          <el-form-item label="品牌：" prop="brandNames">
            <el-input v-model="brandNames" :disabled="true"></el-input>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="品类编码：" prop="categoryCode">
            <el-input v-model="brandInfo.brandCode" :disabled="true"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 2位正整数</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="请输入品类名称：" prop="categoryName">
            <el-input v-model="brandInfo.brandName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过20个字符</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="editCategory">编辑</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      brandNames: "",
      brandInfo: {
        brandId: "",
        brandCode: "",
        brandName: ""
      },
      rules: {
        brandName: [
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getBrandTypeById: function(id) {
      let _this = this;
      let param = {
        url: "/api/dictionaryBrand/getDictionaryBrandInfoById",
        params: {
          brandId: id
        }
      };

      _this.$store.dispatch("getBrandTypeById", param).then(() => {
        _this.brandInfo =
          _this.$store.state.brandType.brandTypeInfoData.brandInfo;
      });
    },
    //编辑品类
    editCategory: function() {
      let _this = this;
      _this.$refs.brandForm.validate(isPass => {
        if (isPass) {
          let param;
          param = {
            url: "/api/dictionaryBrand/updateDictionaryBrandInfo",
            params: {
              brandId: _this.brandInfo.brandId,
              brandName: _this.brandInfo.brandName
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "品类信息修改成功",
                  type: "success"
                });
                this.$router.push({
                  name: "brandTypeIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善品类信息!",
            type: "warning"
          });
        }
      });
    }
  },
  created() {
    let _this = this;
    let id = this.$route.params.brandId;
    let brandNames = this.$route.params.brandNames;
    _this.brandNames = brandNames;
    if (id !== null && id !== "" && id !== undefined) {
      _this.getBrandTypeById(id);
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
